// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2xMBd","range":"MonthRangeSwitch_range__39zlc","disabled":"MonthRangeSwitch_disabled__2oKa_"};